import React from 'react';
import ProductMarkers from "../../../ProductMarkers";
import { ProductMarker } from "../../../ProductMarkers/types";
import { ProductTileProps } from "../../../ProductTile/types";
const MarketingMarker = ({ marketingMarkerText, marketingMarkerType, brandName, isExternalBrand, markers, hasOneMarkerPerLine = false, shouldReserveMarkerSpace = false, productMarkers, markerWrapperClassname, marketingMarkerSpacing, optimizelyClasses = {}, productMarkerClassName, }) => {
    const getMarkers = () => {
        const shouldShowBrandName = !!brandName && isExternalBrand;
        if (shouldShowBrandName) {
            return [
                {
                    text: brandName,
                    type: 'custom',
                },
            ];
        }
        // hm-apps compatibility
        if (productMarkers === null || productMarkers === void 0 ? void 0 : productMarkers.length) {
            return productMarkers.map((marker) => {
                return Object.assign({ text: marker.text, hexColor: marker.hexColor }, (marker.type && { type: marker.type }));
            });
        }
        if (marketingMarkerText && marketingMarkerType) {
            return marketingMarkerText.split(',').map((marker) => {
                return {
                    text: marker,
                    type: marketingMarkerType,
                };
            });
        }
        if (markers === null || markers === void 0 ? void 0 : markers.length) {
            return markers;
        }
        return undefined;
    };
    const shouldUseMultipleRowsForMarkers = hasOneMarkerPerLine || !!productMarkers;
    const internalMarkers = getMarkers();
    const marketTypeClassName = marketingMarkerType
        ? `${optimizelyClasses === null || optimizelyClasses === void 0 ? void 0 : optimizelyClasses.BRAND_MARKER} ${markerWrapperClassname}`
        : markerWrapperClassname;
    if (!shouldReserveMarkerSpace && internalMarkers === null) {
        return null;
    }
    return (React.createElement(ProductMarkers, { markers: internalMarkers, shouldReserveMarkerSpace: shouldReserveMarkerSpace, hasOneMarkerPerLine: shouldUseMultipleRowsForMarkers, wrapperClassName: marketTypeClassName, marketingMarkerSpacing: marketingMarkerSpacing, productMarkerClassName: productMarkerClassName }));
};
export default MarketingMarker;
//# sourceMappingURL=MarketingMarker.js.map